import React from 'react';

// Payment status badge. Renders nothing when a ticket has no payment activity —
// absence is the common case and shouldn't cost visual space.
//
// On a partial payment the badge names BOTH numbers. "Paid $100.00" alone reads
// as settled at the counter, which is the double-charge failure mode this whole
// feature exists to prevent — just inverted.
export default function PaymentBadge({ payment, theme = 'dark', compact = false }) {
  if (!payment || !payment.state) return null;
  const isDark = theme !== 'light';
  const money = (n) => `$${Number(n || 0).toFixed(2)}`;

  const palettes = {
    paid:    { bg: isDark ? '#0f2a15' : '#d4edda', color: isDark ? '#2ecc71' : '#1a7a3a', icon: '✓' },
    pending: { bg: isDark ? '#2a1f0a' : '#fef3e2', color: '#e67e22',                       icon: '◷' },
    failed:  { bg: isDark ? '#2a0f0f' : '#fde8e8', color: '#e74c3c',                       icon: '⚠' },
    deposit_failed: { bg: isDark ? '#2a1f0a' : '#fef3e2', color: '#e67e22',                icon: '⚠' },
    expired: { bg: isDark ? '#243050' : '#e8e8e0', color: isDark ? '#7a8ba8' : '#7a7a72',  icon: '⊘' },
  };
  const p = palettes[payment.state] || palettes.expired;

  let label;
  if (payment.state === 'paid') {
    // "Prepaid" deliberately, not "Paid" — this is money collected before
    // pickup that sits as a credit on the customer's Lightspeed account until
    // staff ring the ticket up. Lightspeed's own Paid pill means the register
    // closed the sale, which is a different fact.
    const short = payment.total != null && payment.paid + 0.01 < payment.total;
    label = short && !compact
      ? `Prepaid ${money(payment.paid)} of ${money(payment.total)}`
      : short ? `Prepaid ${money(payment.paid)} / ${money(payment.total)}`
      : `Prepaid ${money(payment.paid)}`;
  } else if (payment.state === 'deposit_failed') {
    // Says the two things a clerk needs: they paid, and don't take it again.
    label = compact ? `Paid ${money(payment.paid)} — not in LS` : `Paid ${money(payment.paid)} — not recorded in Lightspeed`;
  }
  else if (payment.state === 'pending') label = `Link sent ${money(payment.pending)}`;
  else if (payment.state === 'failed')   label = 'Card declined';
  else                                    label = 'Link expired';

  return (
    <span style={{ fontSize: 11, padding: '3px 9px', borderRadius: 4, fontWeight: 500,
      background: p.bg, color: p.color, whiteSpace: 'nowrap',
      display: 'inline-flex', alignItems: 'center', gap: 4 }}>
      {p.icon} {label}
    </span>
  );
}